import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header/Header';
import Sidebar from './components/Sidebar/Sidebar';
import Home from './components/Home/Home';
import HomePage from './pages/HomePage';
import TurnosAsignados from './components/TurnosAsignados/TurnosAsignados';
import CalcularPoblacion from './components/CalcularPoblacion/CalcularPoblacion';
import Login from './components/Login/Login';
import UserProfile from './components/UserProfile/UserProfile';

// A wrapper component to handle protected routes
const ProtectedRoute = ({ isAuthenticated, children }) => {
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
  };

  const [sidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Close sidebar on mobile when route changes
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };

    handleResize(); // Set initial state
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Router>
      <div className="App">
        {isAuthenticated && (
          <>
            <Header onLogout={handleLogout} onToggleSidebar={toggleSidebar} />
            <Sidebar isOpen={sidebarOpen} onToggle={toggleSidebar} />
          </>
        )}
        <main className={isAuthenticated ? (sidebarOpen ? 'main-content expanded' : 'main-content') : ''}>
          <div style={{ padding: '20px' }}>
            <Routes>
            <Route path="/login" element={
              isAuthenticated ? 
              <Navigate to="/home" replace /> : 
              <Login onLogin={handleLogin} />
            } />
            
            <Route path="/home" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <HomePage />
              </ProtectedRoute>
            } />
            <Route path="/dashboard" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Home />
              </ProtectedRoute>
            } />
            
            <Route path="/turnos-asignados" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <TurnosAsignados />
              </ProtectedRoute>
            } />
            
            <Route path="/calcular-poblacion" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <CalcularPoblacion />
              </ProtectedRoute>
            } />
            
            <Route path="/perfil" element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <UserProfile />
              </ProtectedRoute>
            } />
            
            <Route path="/" element={
              isAuthenticated ? 
              <Navigate to="/home" replace /> : 
              <Navigate to="/login" replace />
            } />
            </Routes>
          </div>
        </main>
      </div>
    </Router>
  );
}

export default App;
